export const VIRTUAL_SITE_ADDRESS_TYPES = [
  { value: 'warehouse', label: 'Warehouse' },
  { value: 'manufacturing_unit', label: 'Manufacturing Unit' },
  { value: 'servicing_center', label: 'Servicing Center' },
];

export const VIRTUAL_SITE_INSTRUCTION_STEPS = [
  'Provide the physical address where operations take place and the contact info for the on-site Point of Contact (POC).',
  'The POC will receive a unique verification link via email and text (SMS).',
  'The POC will be prompted to install Truepic application using the link',
  'The POC will follow the on-screen prompts to capture site photos and submit them for verification.',
];

export const getTruepicStatusLabelAndColor = (
  status?: string
): { label?: string; color?: 'success' | 'warning' | 'error' | 'info' } => {
  let label = status;
  let color: 'success' | 'warning' | 'error' | 'info' | undefined;

  if (status === 'Pending') {
    color = 'warning';
  } else if (['Link Generated', 'Initiated'].includes(status || '')) {
    color = 'info';
  } else if (status === 'Errored') {
    label = 'Failed';
    color = 'error';
  } else if (['Completed', 'Approved'].includes(status || '')) {
    color = 'success';
  } else {
    label = status;
    color = 'info';
  }

  return { label, color };
};
